var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile07 = function SvgFile07(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.942l5.25 5.25v11.942q0 .758-.525 1.283t-1.283.525zm7.192-13V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.002 18.75h-1.5v-6.5h1.5zM12.75 18.75h-1.5V10h1.5zM16.501 18.75h-1.5v-3.5h1.5z"
  })));
};
export default SvgFile07;